<template>
  <date-range-picker
    v-model="dateRange"
    :opens="getOpens()"
    :days-of-week="['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']"
    :month-names="['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']"
    :min-date="minDate"
    :max-date="maxDate"
    :ranges="ranges"
    @update="updateValues"
  >
    <template
      v-slot:input="picker"
      style="min-width: 350px;"
    >
      {{ picker.startDate | date }} - {{ picker.endDate | date }}
    </template>
  </date-range-picker>

</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'

// you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { coreApiPageDateRangeFilterObject } from '@/coreApi/filters/coreApiPageDateRangeFilter'

// eslint-disable-next-line import/no-extraneous-dependencies,no-unused-vars
const moment = require('moment')

// eslint-disable-next-line no-unused-vars
const querystring = require('querystring')

export default {
    components: {
        DateRangePicker,
    },
    filters: {
        date(val) {
            return val ? moment(val).format('DD MMM') : ''
        },
    },
    props: {
        filters: {
            type: Array,
            default: () => coreApiPageDateRangeFilterObject.getFilterList(),
        },
    },
    data() {
        const pageDateRangeFilter = coreApiPageDateRangeFilterObject.getQueryStringFilter()
        const initialDateValue = {
            startDate: new Date(),
            endDate: new Date(),
        }
        let selectedDateValue = initialDateValue

        if (pageDateRangeFilter && typeof pageDateRangeFilter.datetimeRange !== 'undefined' && pageDateRangeFilter.datetimeRange.length) {
            try {
                selectedDateValue = JSON.parse(pageDateRangeFilter.datetimeRange[0].slice(3))
            } catch (e) {
                selectedDateValue = initialDateValue
            }
        }

        const maxDate = new Date()
        const minDate = new Date('Mar 23, 2022 00:00:00')

        const today = new Date()
        today.setHours(0, 0, 0, 0)

        const yesterday = new Date()
        yesterday.setDate(today.getDate() - 1)
        yesterday.setHours(0, 0, 0, 0)

        const thisWeekStart = this.getFirstDayOfWeek(today)
        thisWeekStart.setHours(0, 0, 0, 0)

        const thisWeekEnd = today

        const thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1)
        thisMonthStart.setHours(0, 0, 0, 0)

        const thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0)
        thisMonthEnd.setHours(0, 0, 0, 0)

        const ranges = {
            Today: [today, today],
            Yesterday: [yesterday, yesterday],
            'This week': [thisWeekStart, thisWeekEnd],
            'This month': [thisMonthStart, thisMonthEnd],
            // 'This year': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
            // 'Last month': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
        }

        return {
            dateRange: selectedDateValue,
            maxDate,
            minDate,
            ranges,
        }
    },
    methods: {
        getOpens() {
            return 'center'
        },
        isMobile() {
            return window.innerWidth < 768
        },
        updateValues(data) {
            if (data) {
                const startDate = moment(data.startDate, 'YYYY-MM-DDTHH:mm:ss.SSSSZ')
                const endDate = moment(data.endDate, 'YYYY-MM-DDTHH:mm:ss.SSSSZ')
                const dataObject = {
                    startDate: startDate.format('YYYY-MM-DD'),
                    endDate: endDate.format('YYYY-MM-DD'),
                }
                const filters = { datetimeRange: [`dr:${JSON.stringify(dataObject)}`] }
                const newPath = coreApiPageDateRangeFilterObject.getFilterUrl(filters)
                if (newPath !== this.$route.fullPath) {
                    this.$router.push(newPath)
                }
            }
        },
        getFirstDayOfWeek(d) {
            // 👇️ clone date object, so we don't mutate it
            const date = new Date(d)
            const day = date.getDay() // 👉️ get day of week

            // 👇️ day of month - day of week (-6 if Sunday), otherwise +1
            const diff = date.getDate() - day + (day === 0 ? -6 : 1)

            return new Date(date.setDate(diff))
        },

    },
}
</script>
